import { render } from "./review-modal.vue?vue&type=template&id=18852dcb&scoped=true"
import script from "./review-modal.vue?vue&type=script&lang=js"
export * from "./review-modal.vue?vue&type=script&lang=js"

import "./review-modal.vue?vue&type=style&index=0&id=18852dcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18852dcb"]])

export default __exports__